import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Vue from 'vue';
import router from "./router";
import store from "./store";
import NProgress from 'nprogress'; // progress bar

import 'nprogress/nprogress.css'; // progress bar style

import notification from 'ant-design-vue/es/notification';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { generateIndexRouter } from '@/utils/util';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/user/login', '/user/bindWechat', '/visual/view'].concat(window.app_whiteList); // no redirect whitelist

router.beforeEach(function (to, from, next) {
  console.log('to, from, next', to, from, next);
  NProgress.start(); // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN)) {
    var topath = to.path;

    if (topath == "/") {
      topath = window.localStorage.getItem('homeUrl') && window.localStorage.getItem('homeUrl') != 'null' ? window.localStorage.getItem('homeUrl') : '/monitor/map';
    }
    /* has token */


    if (to.path === '/user/login') {
      /*if (window.localStorage.getItem('projectCode') && window.localStorage.getItem('projectCode') != 'null') {
      next({ path: '/tenant/' + window.localStorage.getItem('projectCode') + '/monitor/map', query: to.query })
      } else {
        next({ path: '/monitor/map', query: to.query })
      }*/
      next({
        path: window.localStorage.getItem('homeUrl') && window.localStorage.getItem('homeUrl') != 'null' ? window.localStorage.getItem('homeUrl') : '/monitor/map',
        query: to.query
      });
      NProgress.done();
    } else {
      console.log('tore.getters.permissionList', store.getters.permissionList);

      if (store.getters.permissionList.length === 0 && window.app_whiteList.indexOf(window.location.pathname) === -1) {
        store.dispatch('GetPermissionList').then(function (res) {
          var menuData = res.result.menu;

          if (menuData === null || menuData === '' || menuData === undefined) {
            return;
          }

          var constRoutes = []; //将后台菜单添加到路由列表中

          constRoutes = generateIndexRouter(menuData); // 添加主界面路由

          store.dispatch('UpdateAppRouter', {
            constRoutes: constRoutes
          }).then(function () {
            // 根据roles权限生成可访问的路由表
            // 动态添加可访问路由表
            router.addRoutes(store.getters.addRouters);
            var redirect = decodeURIComponent(from.query.redirect || to.path);

            if (to.path === redirect) {
              // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record

              /*if (topath!="/404"&&window.localStorage.getItem('routerfrom') != to.path && to.path.indexOf('/tenant/') == -1 && window.localStorage.getItem('projectCode') && window.localStorage.getItem('projectCode') != 'null') {
                window.localStorage.setItem('routerfrom', '')
                next({
                  path: '/tenant/' + window.localStorage.getItem('projectCode') + topath,
                  replace: true,
                  query: to.query
                })
              } else {
                next({ ...to, replace: true })
              }*/
              next(_objectSpread(_objectSpread({}, to), {}, {
                replace: true
              }));
            } else {
              // 跳转到目的路由

              /*if (topath!="/404"&&window.localStorage.getItem('routerfrom') != to.path && to.path.indexOf('/tenant/') == -1 && window.localStorage.getItem('projectCode') && window.localStorage.getItem('projectCode') != 'null') {
                window.localStorage.setItem('routerfrom', '')
                next({ path: '/tenant/' + window.localStorage.getItem('projectCode') + redirect, query: to.query })
              } else {
                 next({ path: redirect, query: to.query })
              }*/
              next({
                path: redirect,
                query: to.query
              });
            }
          });
        }).catch(function () {
          if (window.app_whiteList.indexOf(window.location.pathname) !== -1) {
            NProgress.done();
          } else {
            /* notification.error({
             message: '系统提示',
             description: '请求用户信息失败，请重试！'
            })*/
            store.dispatch('Logout').then(function () {
              next({
                path: '/user/login',
                query: {
                  redirect: to.fullPath
                }
              });
            });
          }
        });
      } else {
        /*if (topath!="/404"&&window.localStorage.getItem('routerfrom') != to.path && to.path.indexOf('/tenant/') == -1) {
          window.localStorage.setItem('routerfrom', '')
          next({
            path: '/tenant/' + window.localStorage.getItem('projectCode') + topath,
            replace: true,
            query: to.query
          })
        } else {
          next()
        }*/
        next();
      }
    }
  } else {
    console.log('to', to);

    if (whiteList.indexOf(to.path) !== -1) {
      // 在免登录白名单，直接进入
      next();
    } else {
      // 青岛部分首页免登录处理
      if (window.domainURL == 'https://www.fbsws.qdshqy.com:7001/env' && to.path == '/ds/view' && to.query.isLogin) {
        next();
        return;
      }

      next({
        path: '/user/login',
        query: {
          redirect: to.fullPath,
          tenant: window.localStorage.getItem('tenant')
        }
      });
      NProgress.done(); // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
});
/*router.onError(err => {
  if (err.code == 'MODULE_NOT_FOUND') {
    const reg = /\'(.*?)\'/
    const url = reg.exec(err.message)
    var query = JSON.parse(window.sessionStorage.getItem('query'))
    if (url.length >= 2) {
      window.localStorage.setItem('routerfrom', url[1].replace('./' + window.localStorage.getItem('projectCode') + '/', '/'))
      router.push({ path: url[1].replace('./' + window.localStorage.getItem('projectCode') + '/', '/').replace(".vue",""), query })
    } else {
      router.push('/404')
    }
  }
})*/

router.afterEach(function () {
  NProgress.done(); // finish progress bar
});